import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular/standalone';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { AuthService } from '../../core/auth.service';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent, ReactiveFormsModule],
    selector: 'app-login',
    styleUrls: ['./login.page.scss'],
    templateUrl: './login.page.html'
})
export class LoginPage implements OnInit {
  public loginForm: FormGroup;
  isAppleLogin: boolean = false;

  constructor(
    private afAuth: Auth,
    private auth: AuthService, 
    private fb: FormBuilder, 
    private platform: Platform,
    private router: Router, 
  ) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.loginForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      password: ['', Validators.compose([Validators.minLength(6), Validators.required])]
    })
  }

  /// Social Login

  async signInWithApple() {
    await this.auth.appleLogin();
    return this.router.navigate(['/account/dashboard']);
  }

  async signInWithGoogle() {
    await this.auth.googleLogin();
    return this.router.navigate(['/account/dashboard']);
  }

  /// Email Login

  async login() {
    await this.auth.emailLogin(this.loginForm.value.email.trim(), this.loginForm.value.password.trim())
    return this.router.navigate(['/account/dashboard']);
  }

  async logout() {
    this.auth.signOut();
    return await this.router.navigate(['/']);
  }

  ngOnInit() {
    if (this.platform.is('cordova')) {
      if (this.platform.is('ios')) {
        this.isAppleLogin = true;
      }
    }
    this.afAuth.onAuthStateChanged((user) => {
      if (user) {
        this.auth.presentToast('Welcome!','success');
        this.auth.updateUserData(user).then(() => {
          return this.router.navigate(['/account/dashboard']);
        });
      }
    })
  }
}
